import authService from "../components/api-authorization/AuthorizeService";

export async function ApiFetch({ endpoint, method = 'GET', body = null, contentType = 'application/json', enableLog = false }, rejectWithValue) {
    try {
        const token = await authService.getAccessToken();
        const headers = new Headers({
            'Content-Type': contentType,
            ...(token && { 'Authorization': `Bearer ${token}` })
        });

        const response = await fetch(window.Config.apiUrl + endpoint, {
            method,
            headers,
            body: body ? JSON.stringify(body) : null,
            redirect: 'follow'
        });

        if (enableLog) {
            console.log("Endpoint:", endpoint);
            console.log("Body:", body);
        }

        if (!response.ok) {
            return rejectWithValue("Er is iets fout gegaan...");
        }

        if (enableLog) {
            console.log('Response:', response)
        }

        return response.json();
    } catch (error) {
        return rejectWithValue("Er is iets fout gegaan...");
    }
};

export function CreateAsyncStatusHandler(builder, asyncThunk, stateKey, enableLog = false) {
    builder
        .addCase(asyncThunk.pending, (state) => {
            state[stateKey].status = 'loading';
        })
        .addCase(asyncThunk.fulfilled, (state, action) => {
            if (enableLog) {
                console.log('Action payload', action.payload)
            }
            state[stateKey].status = 'success';
            state[stateKey].data = action.payload;
        })
        .addCase(asyncThunk.rejected, (state) => {
            state[stateKey].status = 'failed';
        });
};

export function CreateAsyncStatusHandlers(builder, asyncThunk, statusKey, onFulfilled = null) {
    builder
        .addCase(asyncThunk.pending, (state) => {
            state[statusKey] = 'loading';
        })
        .addCase(asyncThunk.fulfilled, (state, action) => {
            state[statusKey] = 'success';
            if (onFulfilled) onFulfilled(state, action);
        })
        .addCase(asyncThunk.rejected, (state) => {
            state[statusKey] = 'failed';
        });
};

export function ResetSliceState(state, keysToReset = null, defaults = {}) {
    const keys = keysToReset || Object.keys(state);

    keys.forEach(key => {
        const slice = state[key];

        if (slice && typeof slice === 'object' && 'status' in slice && 'data' in slice) {
            const defaultValue = defaults[key]?.data ?? null;
            const defaultStatus = defaults[key]?.status ?? null;

            slice.data = defaultValue;
            slice.status = defaultStatus;
        }
    });
};
